import { render } from "./PatientDataPFT.vue?vue&type=template&id=1f5c906e&scoped=true"
import script from "./PatientDataPFT.vue?vue&type=script&lang=js"
export * from "./PatientDataPFT.vue?vue&type=script&lang=js"

import "./PatientDataPFT.vue?vue&type=style&index=0&id=1f5c906e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4192554447/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f5c906e"]])

export default __exports__